import { createSlice } from '@reduxjs/toolkit';

import * as reducers from 'store/reducers/pdpStateReducer';
import { IPDPState } from 'store/types/pdpStateTypes';

export const initialState: IPDPState = {
  bigBuyBarView: 'new',
  focusedWindow: null,
  initialCategoryWindowPosition: null,
  misc: {},
  mobileView: 'main',
  openWindows: [],
  positionOffset: 0,
  previousMobileView: 'none',
  size: null,
};

export const pdpStateSlice = createSlice({
  name: 'pdpState',
  initialState,
  reducers,
});

export const {
  addWindow,
  clearMisc,
  removeWindow,
  resetWindows,
  setBigBuyBarView,
  setInitialCategoryWindowPosition,
  setMobileView,
  setSize,
  setWindowFocus,
  updateMisc,
} = pdpStateSlice.actions;
export default pdpStateSlice.reducer;
